import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logoLightPng from "../../assets/images/curbdash_logo.png";
import logoLightSvg from "../../assets/images/cs_favicon.webp";

const Sidebar = props => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [fullName, setFullName] = useState("Admin");
  const [isToggled, setIsToggled] = useState(true);

  useEffect(() => {
    setFullName(user.full_name);

    // observer to track body class changes
    const observer = new MutationObserver(() => {
      const body = document.body;
      // check the body class to decide if sidebar should be toggled
      const hasCollapsed = body.classList.contains("vertical-collpsed");
      const hasEnabled = body.classList.contains("sidebar-enable");

      // update your state based on body classes
      setIsToggled(!(hasCollapsed && hasEnabled));
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [user.full_name]);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <div className="vertical-menu" style={{ background: "black" }}>
      <div className="navbar-brand-box" style={{ background: "black" }}>
        <div className="logo logo-light">
          <span className="logo-sm">
            <img style={{ cursor: "pointer" }} onClick={() => {
              tToggle();
            }} src={logoLightSvg} alt="" height="30" />
          </span>
          <span className="logo-lg">
            <img src={logoLightPng} style={{ marginTop: -9, marginLeft: -25 }} alt="" height="32" />
            <i
              onClick={() => {
                tToggle();
              }}
              style={{ marginLeft: 35, fontSize: 20, color: "white", cursor: "pointer" }}
              className={`fa ${isToggled ? "fa-arrow-left" : "fa-thumbtack"}`} />
          </span>
        </div>
        {isToggled && <span style={{ color: "white" }}>{fullName}</span>}
      </div>
      <div data-simplebar className={`h-100 ${isToggled ? "mt-4" : ""}`}>
        <SidebarContent />
      </div>
      <div className="sidebar-background"></div>
    </div>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStatetoProps)(withRouter(withTranslation()(Sidebar)));